import React from 'react';
import i18n from 'util/i18n';

// TODO: Resolve the conflict between the lint rule and the format on save.
// eslint-disable-next-line func-names
const OfficialWebsite = function () {
  return (
    <div className="usa-banner mobile-hidden">
      <div className="usa-accordion">
        <div className="usa-banner-header">
          <div className="usa-grid usa-banner-inner">
            <img src="/img/favicons/favicon-57.png" alt="U.S. flag" />
            <p>{i18n.t('app.banner.title')}</p>
            <button
              type="button"
              className="usa-accordion-button usa-banner-button official-website-button"
              aria-expanded="false"
              aria-controls="gov-banner"
            >
              <span className="usa-banner-button-text official-website-button-text">
                {i18n.t('app.banner.button')}
              </span>
            </button>
          </div>
        </div>
        <div
          className="usa-banner-content usa-grid usa-accordion-content"
          id="gov-banner"
        >
          <div className="usa-banner-guidance-gov usa-width-one-half">
            <img
              className="usa-banner-icon usa-media_block-img"
              src="/img/icon-dot-gov.svg"
              alt="Dot gov"
            />
            <div className="usa-media_block-body">
              <p>
                <strong>{i18n.t('app.banner.witty')}</strong>
                <br />
                {i18n.t('app.banner.extension')}
              </p>
            </div>
          </div>
          <div className="usa-banner-guidance-ssl usa-width-one-half">
            <img
              className="usa-banner-icon usa-media_block-img"
              src="/img/icon-https.svg"
              alt="SSL"
            />
            <div className="usa-media_block-body">
              <p>{i18n.t('app.banner.ssl')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfficialWebsite;
